import {NgModule} from "@angular/core";
import {Http, RequestOptions, XHRBackend} from "@angular/http";
import {CerbaAuthService, httpFactory} from "@digicerba/common";
import {
  IDossierBloqueWebServiceClient,
  HttpClient,
  IAuditWebServiceClient,
  IDocumentWebServiceClient,
  ICorrespondantWebServiceClient,
  INotificationsCommonWebServiceClient,
  ITechnicWebServiceClient,
  IUserInformationsWebServiceClient, IInstanceModeleFormulaireWebServiceClient
} from "@resources/resources";

import {ResourcesClient} from "./resources.client";
import { CORRESPONDANT_CLIENT, USER_INFO_CLIENT } from "@digicerba/common/resources/tokens/injectionTokens";

var resources: Array<any> = [
  /** Liste des resources du fichier resources.ts*/
  { provide : CORRESPONDANT_CLIENT, useClass : ICorrespondantWebServiceClient },
  { provide : USER_INFO_CLIENT, useClass : IUserInformationsWebServiceClient},
  IDossierBloqueWebServiceClient,
  ICorrespondantWebServiceClient,
  IUserInformationsWebServiceClient,
  IAuditWebServiceClient,
  IDocumentWebServiceClient,
  INotificationsCommonWebServiceClient,
  ITechnicWebServiceClient,
  CerbaAuthService,
  IInstanceModeleFormulaireWebServiceClient
];

@NgModule({
  providers: [...resources,
    {
      provide: Http,
      useFactory: httpFactory,
      deps: [XHRBackend, RequestOptions, CerbaAuthService]
    },
    {provide: HttpClient, useClass: ResourcesClient}]
})
export class ResourcesModule {

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/resources/resources.module.ts